import { TFunction } from 'i18next';

const videoUrls = ['2Lk-oqV7cJI', 'oy-Gxr2yw48'];
const videoIds = ['how-to-use', 'negative-reviews'];

export const getVideoBlocksData = (t: TFunction) => {
  const blocks = t('mainPage.videoBlocks', { returnObjects: true }) as Array<{
    title: string;
    steps: string[];
  }>;

  return blocks.map((block, index) => ({
    ...block,
    id: videoIds[index],
    videoUrl: videoUrls[index],
  }));
};
